// Оффлайн/реконнект-баннер (SPEC §4.7, FR-PWA-03/04). Отражает select.connStatus() стора: не 'open'
// → ненавязчивая плашка. protocol.outdated (select.needReload) → блокирующий экран «Обновите страницу».
// app-ui лишь ОТРАЖАЕТ статус — очередь держит транспорт, оптимистику — стор.

import type { CSSProperties } from 'react'
import { useCallback } from 'react'
import { Button } from '@tele-chat/design-system'
import { useSelector } from '../store/StoreContext.js'
import { strings } from '../i18n/strings.js'

export function ConnBanner(): JSX.Element | null {
  const status = useSelector((s) => s.select.connStatus())
  const needReload = useSelector((s) => s.select.needReload())
  const reload = useCallback(() => {
    if (typeof window !== 'undefined') window.location.reload()
  }, [])

  if (needReload) {
    const overlay: CSSProperties = {
      position: 'fixed',
      inset: 0,
      zIndex: 'var(--z-viewer)' as unknown as number,
      background: 'var(--color-overlay)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 'var(--space-3)',
      color: 'var(--color-text-inverse)',
      padding: 'var(--space-4)',
      textAlign: 'center',
    }
    return (
      <div data-outdated-overlay="" style={overlay}>
        <div style={{ fontSize: 'var(--font-lg)', fontWeight: 'var(--weight-semibold)' }}>
          {strings.conn.outdated}
        </div>
        <Button variant="primary" onClick={reload}>
          {strings.conn.reload}
        </Button>
      </div>
    )
  }

  if (status === 'open') return null

  const label =
    status === 'reconnecting' || status === 'connecting' ? strings.conn.reconnecting : strings.conn.offline
  const bar: CSSProperties = {
    position: 'sticky',
    top: 0,
    zIndex: 'var(--z-sticky)' as unknown as number,
    background: 'var(--color-bg-secondary)',
    color: 'var(--color-text-muted)',
    fontSize: 'var(--font-sm)',
    textAlign: 'center',
    padding: '4px var(--space-3)',
    borderBottom: '1px solid var(--color-divider)',
  }
  return (
    <div data-conn-banner="" data-status={status} style={bar}>
      {label}
    </div>
  )
}
